/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum LocationProfileStatus {
    EDITABLE = 'EDITABLE',
    SUBMITTED = 'SUBMITTED',
    CONFIRMED = 'CONFIRMED',
}
